import { formatDate } from '@angular/common';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { MDBModalRef } from '../../../app/shared/services/mdb-modal-stub.service';
import { ToolsConstant } from '../../shared/models/constants';
import { Enums } from '../../shared/models/enums';
import { CellRendererTypes } from '../../shared/widgets/data-grid/enums/cell-renderer.enum';
import { FilterTypes } from '../../shared/widgets/data-grid/enums/filter-types.enum';
import { TableColumn } from '../../shared/widgets/data-grid/interfaces/table-column.interface';

@Injectable()
export class ProjectStudyAdminService {
    cols: Array<TableColumn> = [
        {
            field: 'projectCountry',
            header: 'Country',
            sort: true,
            sortName: 'projectCountry',
            filter: { type: FilterTypes.text }
        },
        {
            field: 'buildingType',
            header: 'Building Type',
            sort: true,
            sortName: 'buildingType',
            filter: {
                type: FilterTypes.select, selectOptions: ToolsConstant.buildingType
            },
        },
        {
            field: 'projectName',
            header: 'Project Name',
            sort: true,
            sortName: 'projectName',
            filter: { type: FilterTypes.text },
            cellRenderer: {
                //US 23735 - Migrating PS to EDGEAPP
                //only online projects to have <a> link
                type: CellRendererTypes.html,
                //elementType: CellRendererElementTypes.anchor,
                //eventName: 'onSubprojectNameClick',
                renderHtml: this.projectNameCellRenderer
            }
            /*  cellRenderer: {
                  type: CellRendererTypes.event,
                  elementType: CellRendererElementTypes.anchor,
                  eventName: 'onSubprojectNameClick'
              }   */

        },
        {
            field: 'publishedProjName',
            header: 'Project Study Link',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.renderPublishedProjLink
            }
        },
        {
            field: 'projectStudyStatus',
            header: 'Project Study Status',
            sortName: 'projectStudyStatus',
            filter: { type: FilterTypes.text },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.statusCellRenderer
            }
        },
        {
            field: 'projectStudyType',
            header: 'Project Study Type',
            filter: {
                type: FilterTypes.select, selectOptions: [
                    { label: 'All', value: '' },
                    { label: 'Project Level', value: 'Project Level' },
                    { label: 'Subproject Level', value: 'Subproject Level' }
                ]
            },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.statusCellRenderer
            }
        },
        {
            field: 'certificationStage',
            header: 'Certification Stage',
            sortName: 'certificationStage',
            filter: {
                type: FilterTypes.select, selectOptions: ToolsConstant.certificationStage
            },
        },
        {
            field: 'clientDetails',
            header: 'Client Name',
            filter: { type: FilterTypes.text },
        },
        {
            field: 'submittedBy',
            header: 'Submitted By',
            filter: { type: FilterTypes.text },
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.emailIdCellRenderer
            }
        },
        {
            field: 'projectCertifier',
            header: 'Certifier',
            sort: true,
            sortName: 'projectCertifier',
            filter: { type: FilterTypes.text },
        },
        {
            field: 'typology',
            header: 'Typologies',

        },
        {
            field: 'energySavings',
            header: 'Energy Savings',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.savingsCellRenderer
            }
        },
        {
            field: 'waterSavings',
            header: 'Water Savings',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.savingsCellRenderer
            }
        },
        {
            field: 'materialSavings',
            header: 'Material Savings',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.savingsCellRenderer
            }
        },
        {
            field: 'certificationDate',
            header: 'Certification Date',
            sort: true,
            sortName: 'CertificationDate',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'submissionDate',
            header: 'Submission Date',
            sort: true,
            sortName: 'SubmissionDate',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'publishedDate',
            header: 'Published Date',
            sort: true,
            sortName: 'PublishedDate',
            cellRenderer: {
                type: CellRendererTypes.html,
                renderHtml: this.dateCellRenderer
            }
        },
        {
            field: 'typeColumn',
            header: 'Type',
            filter: {
                type: FilterTypes.select, selectOptions: [
                    { label: 'All', value: '' },
                    { label: 'Online', value: 'Online' },
                    { label: 'Migrated', value: 'Migrated' }
                ]
            },
            sort: true,
            sortName: 'typeColumn'
        }
    ];
    modalRef: MDBModalRef;
    confirmationStatus = Enums.confirmationStatus;
    private callbackProjDOcUploadModalClose = new Subject<any>(); // Source
    eventCallbackProjDocuUploadModalClose$ = this.callbackProjDOcUploadModalClose.asObservable(); // Stream
    constructor() { }

    dateCellRenderer(rowData: any, field: any) {
        if (rowData[field]) {

            const value = formatDate(rowData[field], 'yyyy-MM-dd hh:mm a', 'en-US');
            return `<div class="text-truncate" title="` + value + `">` + value + `</div>`;
        } else {
            return '';
        }
    }

    projectNameCellRenderer(rowData: any, field: any) {
        //for online projct alone provide anchor tag
        if (rowData["typeColumn"] != 'Migrated') {
            return '<div class="text-truncate"><a href="javascript:;" onclick="openSubProject(\'' + rowData.projectDetailID + '\');" >' + rowData[field] + '</a></div>';
        }
        else {
            return '<div class="text-truncate" title="' + rowData[field] + '">' + rowData[field] + '</div>';
        }
    }

    fixedTo2Decimal(rowData: any, field: any) {
        if (rowData[field]) {
            const value = parseFloat(rowData[field]);
            return (!Number.isNaN(value)) ? `<span class="text-truncate"
            title="${Number(value.toFixed(2)).toLocaleString()}">${Number(value.toFixed(2)).toLocaleString()}</span>` : rowData[field];
        } else {
            return '';
        }
    }

    savingsCellRenderer(rowData: any, field: any) {
        if (rowData[field]) {
            const percent = parseFloat(rowData[field].replace('%', ''));
            if (!Number.isNaN(percent) && percent >= 20) {
                return `<div class="text-green text-truncate" title="` + rowData[field] + `">` + rowData[field] + '%' + `</div>`;
            } else {
                return rowData[field] + '%';
            }
        } else {
            return '';
        }
    }

    statusCellRenderer(rowData, field) {
        if (rowData[field] && rowData[field] === 'Published') {
            return `<div class="badge rounded-1" style="background-color:#5cb85c;color:#fff;font-weight:500;">` + rowData[field] + `</div>`;
        }
        if (rowData[field] && rowData[field] === 'Pending') {
            return `<div class="badge rounded-1" style="background-color:#f0ad4e;color:#fff;font-weight:500;">` + rowData[field] + `</div>`;
        }
        else {
            return `<div>` + rowData[field] + `</div>`;
        }
    }

    emailIdCellRenderer(rowData, field) {
        if (rowData[field]) {
            return '<a href="mailto:' + rowData[field] + '">' + rowData[field] + '</a>';
        } else {
            return '';
        }
    }

    renderPublishedProjLink(rowData: any): string {
        //US 23735 - Migrating PS  to EDGE APP
        if (rowData.projectStudyStatus === 'Published' || rowData.ProjectDetailId === null) {
            const url = `/project-studies/${rowData.publishedProjName}`;
            return `
            <span class="text-truncate">
                <a href="javascript:;" onclick="openPublishedprojClick('${rowData.publishedProjName}')">
                    <i class="fas fa-link" title="Published Project Study link"></i>
                </a>
            </span>
        `;
        } else {
            // If ProjectStudyStatus is not 'Published', return an empty string
            return '';
        }
    }


}

